/**
 * @file WidgetFactory.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 17th February 2021 10:22:11 am
 * @copyright 2015 - 2021 SKAT LLC, Delive LLC
 * @flow
 */
import type { iExposedView } from 'web-panel/types'
import * as React from 'react'
import * as Widget from './widgets'
import { faCog } from '@fortawesome/free-solid-svg-icons'

export default class WidgetFactory extends React.Component<{}, {}> implements iExposedView<void> {
  async data () {}
  async command () {}
  render () : React.Node {
    return (
      <div className='blueprint-desk h400px'>
        <Widget.Row>
          <Widget.Col>
            <Widget.Icon icon={faCog} standalone spin />
            <Widget.Label standalone>Text Label</Widget.Label>

            <Widget.Action standalone>
              <Widget.Label>Text Label</Widget.Label>
            </Widget.Action>

            <Widget.Action standalone spin>
              <Widget.Icon inverted icon={faCog} />
            </Widget.Action>

            <Widget.Action standalone>
              <Widget.Icon inverted icon={faCog} />
              <Widget.Label>Text Label</Widget.Label>
            </Widget.Action>

          </Widget.Col>

          <Widget.Col>
            <Widget.Input standalone>
              <Widget.Icon icon={faCog} />
              <Widget.Action>
                <Widget.Icon inverted icon={faCog} />
              </Widget.Action>
              <Widget.Action>
                <Widget.Icon spin inverted icon={faCog} />
              </Widget.Action>
            </Widget.Input>
          </Widget.Col>
        </Widget.Row>

        <Widget.Row>
          <Widget.Col>
            <Widget.Input standalone />
          </Widget.Col>
        </Widget.Row>
      </div>
    )
  }
}
